import exampleTheme from "themes/example-theme";
import storemanager from "themes/storemanager";
import standardTheme from "themes/standard-theme";
import nkz3_0 from "themes/nkz3.0";
import finportal from "themes/finportal";
import ciscoIse from "themes/cisco-ise";
import dataCatalog from "themes/data-catalog";
import taxmon from "themes/taxmon";
import armokkTcx from "themes/armokk-tcx";
import boardMaps from "themes/board-maps";
import bmWebProd from "themes/bm_web_prod";
import mobileAppStore from "themes/mobile-app-store";
import infoPage from "themes/info-page";
import sphere from "themes/sphere/index";
import ReactDOM from "react-dom";
import { getClientId } from "theme-lib/utils/getClientId.js";
import React, { lazy, Suspense } from "react";
import "core-js/es";
import Loader from "./Loader.jsx";

const externalThemes = [
  exampleTheme,
  storemanager,
  nkz3_0,
  finportal,
  dataCatalog,
  armokkTcx,
  taxmon,
  ciscoIse,
  boardMaps,
  bmWebProd,
  mobileAppStore,
  infoPage,
  sphere,
];

function render(App) {
  ReactDOM.render(
    <Suspense fallback={<Loader />}>
      <App />
    </Suspense>,
    document.getElementById("root"),
  );
}

const currentClientId = window.kcContext.client?.clientId || getClientId();

const theme = externalThemes.find(({ clientId }) => {
  if (Array.isArray(clientId)) {
    return clientId.find(
      (id) => id.toLowerCase() === currentClientId.toLowerCase(),
    );
  }
  return clientId.toLowerCase() === currentClientId.toLowerCase();
});

if (theme) {
  render(lazy(theme.entry));
} else {
  render(lazy(standardTheme.entry));
}
